import React from 'react';
import { Forms, FloatingMenu, SystemText, ArrayHelpers } from '@salesperformanceint/e4shared';
import { useSelector } from 'react-redux';
import './competencyPicker.css';

export const CompetencyPicker = ({ label, error, mandatory, onChange, value, help }) => {
    const [areaId, setAreaId] = React.useState(-1);
    const [competencyId, setCompetencyId] = React.useState(0);
    const [filteredCompetencies, setFilteredCompetencies] = React.useState([]);
    const [areas, setAreas] = React.useState([]);
    const [init, setInit] = React.useState(false);

    const competencies = useSelector(state => state.dashboard.competencies);
    const showFormHelp = useSelector(state => state.ui.showFormHelp);

    const text = {
        all: SystemText('General/Controls/CompetencyPicker/All'),
        allSelected: SystemText('General/Controls/CompetencyPicker/AllSelected'),
        area: SystemText('General/Controls/CompetencyPicker/Area'),
        areaHelp: SystemText('General/Controls/CompetencyPicker/Area/Help'),
        areaPlaceholder: SystemText('General/Controls/CompetencyPicker/Area/Placeholder'),
        competencyPlaceholder: SystemText('General/Controls/CompetencyPicker/Competency/Help'),
        competencyHelp: SystemText('General/Controls/CompetencyPicker/Competency/Placeholder'),
    };

    React.useEffect(() => {
        init && onChange && onChange({ id: competencyId, areaId });
    }, [competencyId, areaId]);

    React.useEffect(() => {
        if (!init) {
            setAreaId(value?.areaId);
            setCompetencyId(value?.id);
        }

        setInit(true);
    }, [value]);

    React.useEffect(() => {
        if (
            competencyId &&
            ArrayHelpers.existsAndHasLength(filteredCompetencies) &&
            !filteredCompetencies.some(x => x.id === competencyId)
        ) {
            onChange(null);
        }
    }, [competencyId, filteredCompetencies]);

    React.useEffect(() => {
        const temp = competencies
            .reduce((all, comp) => {
                return all.some(a => a.id === comp.area_Id)
                    ? all
                    : all.concat([
                          {
                              id: comp.area_Id,
                              name: comp.area,
                          },
                      ]);
            }, [])
            .sort((a, b) => (a.name > b.name ? 1 : -1));

        setAreas([{ id: -1, name: text.all }].concat(temp));

        setFilteredCompetencies(
            competencies.filter(a => a.area_Id === areaId).sort((a, b) => (a.full_Name > b.full_Name ? 1 : -1))
        );
    }, [competencies, areaId]);

    const areaName = areas?.find(t => t.id === areaId)?.name || text.area;

    const pickButton = (x, i) => (
        <li
            key={`pick-${x.id}`}
            onClick={() => {
                if (x.id !== areaId) {
                    setCompetencyId(0);
                    setAreaId(x.id);
                }
            }}
            className="flex flex-center"
        >
            {x.name}
        </li>
    );

    return (
        <div className="metric-picker">
            <div className={`form-group ${error && 'has-error'}`}>
                <label className="mb5">
                    {label}
                    {mandatory && <span className="mandatory">*</span>}
                </label>
                {showFormHelp && (help || text.areaHelp) && (
                    <span className="form-control-help">{help || text.areaHelp}</span>
                )}
                <div className="flex mbm10">
                    <FloatingMenu buttonText={`${areaName}`}>{areas.map((t, i) => pickButton(t, i))}</FloatingMenu>
                    <div className="flex-grow ml10">
                        <Forms.Select
                            label={null}
                            readonly={areaId < 0}
                            value={competencyId}
                            placeholder={
                                areaId < 0 ? text.allSelected : areaId ? text.areaPlaceholder : text.competencyPlaceholder
                            }
                            onChange={val => setCompetencyId(val || 0)}
                            help={showFormHelp ? text.competencyHelp : ''}
                            data={filteredCompetencies}
                        />
                    </div>
                </div>
                {error && <span className="help-block mt0">{error}</span>}
            </div>
        </div>
    );
};

export default CompetencyPicker;
